import { render, staticRenderFns } from "./ServicesView.vue?vue&type=template&id=be1f9b0e&scoped=true"
import script from "../js/Services.js?vue&type=script&lang=js&external"
export * from "../js/Services.js?vue&type=script&lang=js&external"
import style0 from "./ServicesView.vue?vue&type=style&index=0&id=be1f9b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1f9b0e",
  null
  
)

export default component.exports